import React from 'react'
import classes from './Courses.module.css'

const Courses = (props) => {

    return (
        <div className={classes.container}>
            <p className={classes.mainHeading}>Our Plans</p>
            <div className={classes.box}>
                <div className={classes.items1}>
                    <p className={classes.heading1}>
                        Starting From
                    </p>
                    <p className={classes.heading2}>

                         <i class="fa fa-inr"  style={{"fontSize":"0.5em"}}></i>100
                    </p>
                    <p className={classes.content}>
                        <ul >
                        <li style={{'listStyleType':"disc",'margin':'10px'}}>Starting from Rs. 100/- per semester or year</li>
                        <li style={{'listStyleType':"disc",'margin':'10px'}}><b>Content Available</b> :&nbsp;All content available during the subscribed semester or year </li>
                        </ul>
</p>
                    <center><button className={classes.btn}>Start Now</button></center>
                </div>
                <div className={classes.items}>
                    <p className={classes.heading1}>
                      Free
                </p>
                    <p className={classes.heading2}>
                    0
                    </p>
                    <p className={classes.content}>
                    <ul >
                        <li style={{'listStyleType':"disc",'margin':'10px'}}><b>Price</b> : Free of cost</li>
                        <li style={{'listStyleType':"disc",'margin':'10px'}}><b>Duration</b> : 1 day trial period </li>
                        <li style={{'listStyleType':"disc",'margin':'10px'}}><b>Content Available</b> :&nbsp;Content available for 24 hours, after that user will have limited access</li>
                        </ul>
</p>
                    <center><button className={classes.btn1}>Start Now</button></center>
                </div>
                {/* <div className={classes.items}>
                    <p className={classes.heading1}>
                        Semester
               </p>
                    <p className={classes.heading2}>
                        6
                    </p>
                    <p className={classes.content}>
                        Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                        dunt ut labore et dolore magna aliqua. Quis ipsum suspendisse
                        commodo viverra maecenas ac
                        Lorem ipsum dolor sit amet,
                        dunt ut labore et dolore magna
                        commodo viverra maecenas
                        dunt ut labore et dolore magna aliqua. Quis ipsum suspendisse ultrices gravida. Risus
                        commodo viverra maecenas accumsan lacus vel facilisis.
</p>
                    <center><button className={classes.btn}>Start Now</button></center>
                </div> */}
            </div>
        </div>
    )


}
export default Courses